import React from "react";
import {styled} from "@reside/ui";

const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

/** Title stack beside the checkbox (optional subtitle rows may be added by callers). */
export function ChecklistItemTextColumn({
  children,
  ...rest
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <TextStack data-checklist-item-text-column="" {...rest}>
      {children}
    </TextStack>
  );
}
